<template>
  <div class="commonLiStyle">
    <top-component></top-component>
    <div class="titlePu">
      <div>纸电同步</div>
    </div>
    <div class="commonLiContainer">
      <div class="Comcontainer">
        <div class="TopConTwo">
          <div class="LeftDiv">
            <div class="xueke">
              <div class="title">大众分类</div>
              <div class="xuekeDiv" v-for="(item, index) in xuekeFenlei" :key="0 + index">
                <div class="xuekeTitle">{{item.typeName}}</div>
                <div class="xuekeContent">
                  <span class="spanOneItem" v-for="(item, index1) in item.childPopularTypes" :key="1 + index1"
                    @click="AllClick(item)">
                    {{item.typeName}}
                  </span>
                </div>
              </div>
            </div>
            <div class="xueke">
              <div class="title">学科分类</div>
              <MyListMenu v-bind:data="AllFenlei"></MyListMenu>
            </div>
          </div>
          <div class="xueke-gg">
            <div class="title">中图分类</div>
            <div class="chinesDataStyle" v-for="(item, index) in ChinesData" :key="index" @click="ChinesClick(item)">
              {{item.classifyTypeName}}
            </div>
          </div>
        </div>
      </div>
    </div>
    <bottom-component></bottom-component>
  </div>
</template>

<script>
  import BottomComponent from '../Components/BottomComponent.vue'
  import TopComponent from '../Components/TopComponentcopy.vue'
  import { listpopularTypes, listclassifyTypes, searchlist } from '@/api/img'
  import MyListMenu from '@/components/MyListMenu.vue'
  import Cookies from 'js-cookie'
  export default {
    name: 'SchoolLibrary',
    data() {
      return {
        // 学科分类
        xuekeFenlei: [],
        // 中图分类
        ChinesData: [],
        AllFenlei: [],
      }
    },
    mounted() {
      this.ApiData()
      this.ApiDataChine()
      this.XuekeStyle()
    },
    methods: {
      // 通俗分类[大众分类]数据
      ApiData() {
        listpopularTypes().then(response => {
          this.xuekeFenlei = response.childPopularTypes
        })
      },
      // 中图分类数据
      ApiDataChine() {
        listclassifyTypes().then(response => {
          this.ChinesData = response
        })
      },
      // 学科分类
      XuekeStyle() {
        searchlist().then(response => {
        //   console.log(response)
          this.AllFenlei = response.childSubjects
        })
      },
      // 大众分类
      AllClick(item) {
        // console.log(item)
        let params = {
              gid:'0',
            TitleName: item.typeName,
            publicType: item.typeCode, // 大众分类
            cnIbraryType: '', // 中图分类
            subjectId: '', // 学科类别
            activityTag: '', // 1精品大码洋/2畅销书/3医学/4抗疫图书/5少儿专区/6推荐书单/7工具书
            goodsType: 2
          };
        this.$router.push({
          name: 'LookPublishingPagesType',
          query: {obj: JSON.stringify(params)}
        })
      },
      // 中图分类
      ChinesClick(item) {
         let params = {
              gid:'0',
            TitleName: item.classifyTypeName,
            publicType: '', // 大众分类
            cnIbraryType: item.classifyTypeCode, // 中图分类
            subjectId: '', // 学科类别
            activityTag: '', // 1精品大码洋/2畅销书/3医学/4抗疫图书/5少儿专区/6推荐书单/7工具书
            goodsType: 2
          };
        // console.log(item)
        this.$router.push({
          name: 'LookPublishingPagesType',
          query: {obj:JSON.stringify(params)}
        })
      }
    },
    components: {
      BottomComponent,
      TopComponent,
      MyListMenu
    },
  }
</script>

<style scoped lang="scss">
  .commonLiStyle {
    width: 100%;
    background-color: #f9f9f9;
    overflow-x: hidden;
  }

  /* 1、title */
  .titlePu {
    height: 90px;
    width: 100%;
    background-image: url('../../assets/images/TopChild.png');
  }

  .titlePu>div {
    width: 1200px;
    height: 100%;
    margin: 0px auto;
    display: flex;
    align-items: center;
    color: rgba(51, 51, 51, 1);
    font-size: 24px;
    text-align: left;
    font-weight: 500;
    font-family: PingFang-SC-Bold;
  }

  /* 公共 */
  .commonLiContainer {
    width: 1200px;
    margin-left: calc(50% - 600px);
  }

  .Comcontainer {
    width: 100%;
    margin-top: 30px;
    margin-bottom: 30px;
    font-size: 0px;
  }

  .title {
    height: 50px;
    line-height: 50px;
    margin-left: 15px;
    color: rgba(0, 0, 0, 1);
    font-size: 18px;
    text-align: left;
    font-family: PingFang-SC-Bold;
  }

  /* 1 */
  /* 2 */
  .TopConTwo {
    width: 100%;
    margin-top: 20px;
    font-size: 0px;
  }

  .LeftDiv {
    width: calc(80% - 20px);
    display: inline-block;
  }

  /* 2、1 */
  .xueke {
    width: 100%;
    /* padding: 3px 0px; */
    /* height: 731px; */
    background-color: rgba(255, 255, 255, 1);
    box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.08);
    margin-top: 20px;
  }

  .xuekeDiv {
    width: 100%;
    border-bottom: 1px solid rgba(226, 226, 226, 1);
    padding: 15px 0px;
    position: relative;
    color: rgba(102, 102, 102, 1);
  }

  .xuekeTitle {
    width: 100px;
    font-size: 14px;
    text-align: left;
    font-family: PingFang-SC-Bold;
    display: inline-block;
    position: absolute;
    left: 15px;
    color: rgba(51, 51, 51, 1);
    font-size: 14px;
  }

  .xuekeContent {
    width: calc(100% - 120px);
    margin-left: 120px;
    height: 30px;
    font-size: 14px;
    text-align: left;
    font-family: PingFangSC-Regular;
    display: inline-block;
  }

  .xuekeContent .spanOneItem {
    display: inline-block;
    padding: 0px 20px;
    line-height: 30px;
  }

  .spanOneItem:hover {
    color: #175199;
    cursor: pointer;
  }

  .xuekeContent .spanTwoItem {
    width: 100%;
    background-color: rgba(249, 249, 249, 1);
    margin-top: 20px;
  }

  .childrensStyle {
    padding: 0px 20px;
    display: inline-block;
    line-height: 30px;
  }

  /* 2、2 */
  .xueke-gg {
    width: 20%;
    height: 731px;
    margin-left: 18px;
    background-color: rgba(255, 255, 255, 1);
    box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.08);
    display: inline-block;
    vertical-align: top;
  }

  .chinesDataStyle {
    padding: 5px 10px;
    color: rgba(102, 102, 102, 1);
    font-size: 14px;
    text-align: left;
    font-family: PingFangSC-Regular;
  }

  .chinesDataStyle:hover {
    color: #175199;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/views/ChildPages/Book-Electron.vue